export const Indices = [
  {
    id: 'ndvi',
    value: 'ndvi',
    name: 'NDVI',
    icon: '/indice_thumbs/NDVI.jpg',
    description: 'Normalized Difference Vegetation Index',
    rescale: '-1%2C1'
  },
  {
    id: 'ndwi',
    value: 'ndwi',
    name: 'NDWI',
    icon: '/indice_thumbs/NDWI.jpg',
    description: 'Normalized Difference Water Index',
    rescale: '-1%2C1'
  },
  {
    id: 'vari',
    value: 'vari',
    name: 'VARI',
    icon: '/indice_thumbs/VARI.jpg',
    description: 'Visible Atmospherically Resistant Index',
    rescale: '-1%2C1'
  },
  {
    id: 'ndbi',
    value: 'ndbi',
    name: 'NDBI',
    icon: '/indice_thumbs/NDBI.jpg',
    description: 'Normalized Difference Built-up Index',
    rescale: '-1%2C1'
  },
  {
    id: 'nbri',
    value: 'nbri',
    name: 'NBRI',
    icon: '/indice_thumbs/NBRI.jpg',
    description: 'Normalized Burn Ratio Index',
    rescale: '-1%2C1'
  },
  {
    id: 'evi2-2',
    value: 'evi2-2',
    name: 'EVI2 - 2',
    icon: '/indice_thumbs/EVI2.jpg',
    description: 'Enhanced Vegetation Index 2 - 2',
    rescale: '-1%2C1'
  },
  {
    id: 'evi2',
    value: 'evi2',
    name: 'EVI2',
    icon: '/indice_thumbs/EVITwo.jpg',
    description: 'Enhanced Vegetation Index 2',
    rescale: '-1%2C1'
  },
  {
    id: 'savi',
    value: 'savi',
    name: 'SAVI',
    icon: '/indice_thumbs/SAVI.jpg',
    description: 'Soil Adjusted Vegetation Index',
    rescale: '-1%2C1'
  },
  {
    id: 'rededge2',
    value: 'rededge2',
    name: 'Rededge2',
    icon: '/indice_thumbs/REDEG.jpg',
    description: 'Rededge2',
    rescale: '-1%2C1'
  },
  {
    id: 'nddi',
    value: 'nddi',
    name: 'NDDI',
    icon: '/indice_thumbs/NDDI.jpg',
    description: 'Normalized Difference Drought Index',
    rescale: '-3%2C4'
  },
  {
    id: 'mtvi2',
    value: 'mtvi2',
    name: 'MTVI2',
    icon: '/indice_thumbs/MTVI2.jpg',
    description: 'Modified Triangular Vegetation Index (MTVI2)',
    rescale: '0%2C1'
  },
  // disabled as not available in lens yet
  {
    id: 'gemi',
    value: 'gemi',
    name: 'GEMI',
    icon: '/indice_thumbs/GEMI.png',
    description: 'Global Environmental Monitoring Index',
    rescale: '-1%2C1'
  },
  // disabled as not available in lens yet
  // {
  //   id: "lst",
  //   value: "lst",
  //   name: "LST",
  //   description: "Land Surface Temperature (LST)",
  //   rescale: "-1%2C1",
  // },
  // disabled as not available in lens yet
  // {
  //   id: "smi",
  //   value: "smi",
  //   name: "SMI",
  //   description: "Soil Moisture Index",
  //   rescale: "-1%2C1",
  // },
  {
    id: 'osi',
    value: 'osi',
    name: 'OSI',
    icon: '/indice_thumbs/OSI.jpg',
    description: 'Oil Spill Index (on water surface)',
    rescale: '0%2C2'
  },
  {
    id: 'tvi',
    value: 'tvi',
    name: 'TVI',
    icon: '/indice_thumbs/TVI.jpg',
    description: 'Transformed Vegetation Index',
    rescale: '0%2C1'
  },
  {
    id: 'ndre',
    value: 'ndre',
    name: 'NDRE',
    icon: '/indice_thumbs/NDRE.jpg',
    description: 'Normalized Difference RedEdge Index',
    rescale: '-1%2C1'
  },
  {
    id: 'msavi2',
    value: 'msavi2',
    name: 'MSAVI2',
    icon: '/indice_thumbs/MSAVI2.jpg',
    description: 'Modified Soil-adjusted Vegetation Index',
    rescale: '-0.1%2C1'
  },
  {
    id: 'reci',
    value: 'reci',
    name: 'RECI',
    icon: '/indice_thumbs/RECI.jpg',
    description: 'Red-edge Chlorophyll Index',
    rescale: '0%2C6'
  },
  {
    id: 'ndmi',
    value: 'ndmi',
    name: 'NDMI',
    icon: '/indice_thumbs/NDMI.jpg',
    description: 'Normalized Difference Moisture Index',
    rescale: '-1%2C1'
  },
  {
    id: 'gndvi',
    value: 'gndvi',
    name: 'GNDVI',
    icon: '/indice_thumbs/GNDVI.jpg',
    description: 'Green Normalized Difference Vegetation Index',
    rescale: '-1%2C1'
  },
  {
    id: 'sipi',
    value: 'sipi',
    name: 'SIPI',
    icon: '/indice_thumbs/SIPI.jpg',
    description: 'Structure Insensitive Pigment Index',
    rescale: '0%2C2'
  },
  // disabled as not available in lens yet
  // {
  //   id: "arvi",
  //   value: "arvi",
  //   name: "ARVI",
  //   description: "Atmospherically Resistant Vegetation Index",
  //   rescale: "-1%2C1",
  // },
  {
    id: 'psri',
    value: 'psri',
    name: 'PSRI',
    icon: '/indice_thumbs/PSRI.jpg',
    description: 'Plant Senescence Reflectance Index',
    rescale: '-0.1%2C0.2'
  },
  {
    id: 'gci',
    value: 'gci',
    name: 'GCI',
    icon: '/indice_thumbs/GCI.jpg',
    description: 'Green Chlorophyll Index',
    rescale: '0%2C5'
  },
  {
    id: 'cvi',
    value: 'cvi',
    name: 'CVI',
    icon: '/indice_thumbs/CVI.jpg',
    description: 'Chlorophyll Vegetation index',
    rescale: '0%2C5'
  },
  {
    id: 'ndsi',
    value: 'ndsi',
    name: 'NDSI',
    icon: '/indice_thumbs/NDSI.jpg',
    description: 'Normalized Difference Snow Index',
    rescale: '-1%2C1'
  },
  {
    id: 'msi',
    value: 'msi',
    name: 'MSI',
    icon: '/indice_thumbs/MSI.jpg',
    description: 'Moisture Stress Index',
    rescale: '0%2C3'
  },

  // new indice
  // Thumbnails to be created after colormaps are finalized
  {
    id: 'rendvi',
    value: 'rendvi',
    name: 'RENDVI',
    icon: '/indice_thumbs/RENDVI.png',
    description: 'Red Edge NDVI',
    rescale: '-1%2C1'
  },
  {
    id: 'reip',
    value: 'reip',
    name: 'REIP',
    icon: '/indice_thumbs/REIP.png',
    description: 'Red Edge Inflection Point',
    rescale: '680%2C740'
  },
  {
    id: 'ari',
    value: 'ari',
    name: 'ARI',
    icon: '/indice_thumbs/ARI.png',
    description: 'Anthocyanin Reflectance Index',
    rescale: '0%2C0.2'
  },
  {
    id: 'nmdi_soil',
    value: 'nmdi_soil',
    name: 'NMDI SOIL',
    icon: '/indice_thumbs/NMDI_Soil.png',
    description: 'Normalized Multi-band Drought Index for Soil',
    rescale: '0.5%2C1'
  },
  {
    id: 'nmdi_veg',
    value: 'nmdi_veg',
    name: 'NMDI VEG',
    icon: '/indice_thumbs/NMDI_VEGETATION.png',
    description: 'Normalized Multi-band Drought Index for Vegetation',
    rescale: '0.2%2C0.8'
  },
  {
    id: 'si',
    value: 'si',
    name: 'SI',
    icon: '/indice_thumbs/SI_SALINTY_INDEX.png',
    description: 'Salinity Index',
    rescale: '-1%2C0.2'
  },
  // more new indices
  {
    id: 'cmi',
    value: 'cmi',
    name: 'CMI',
    icon: '/indice_thumbs/CMI.png',
    description: 'Clay Mineral Index',
    rescale: '0%2C255'
  },
  {
    id: 'fmi',
    value: 'fmi',
    name: 'FMI',
    icon: '/indice_thumbs/FMI.png',
    description: 'Ferrous Mineral Index',
    rescale: '0%2C255'
  },
  {
    id: 'ioi',
    value: 'ioi',
    name: 'IOI',
    icon: '/indice_thumbs/IOI.png',
    description: 'Iron Oxide Index',
    rescale: '0%2C255'
  },
  // {
  //   id: 'ci',
  //   value: 'ci',
  //   name: 'CI',
  //   icon: '',
  //   description: 'Cyanobacteria Index',
  //   rescale: '-1%2C1'
  // },
  {
    id: 'ndci',
    value: 'ndci',
    name: 'NDCI',
    icon: '/indice_thumbs/NDCI.png',
    description: 'Normalized Difference Chlorophyll Index',
    rescale: '-1%2C1'
  },
  {
    id: 'fai',
    value: 'fai',
    name: 'FAI',
    icon: '/indice_thumbs/FAI.png',
    description: 'Floating Algae Index',
    rescale: '-1%2C1'
  },
  // {
  //   id: 'mci',
  //   value: 'mci',
  //   name: 'MCI',
  //   icon: '',
  //   description: 'Maximum Chlorophyll Index',
  //   rescale: '-1%2C1'
  // },
  {
    id: 'mndwi',
    value: 'mndwi',
    name: 'MNDWI',
    icon: '/indice_thumbs/MNDWI.png',
    description: 'Modified Normalized Difference Water Index',
    rescale: '-1%2C1'
  },
  {
    id: 'ndti',
    value: 'ndti',
    name: 'NDTI',
    icon: '/indice_thumbs/NDTI.png',
    description: 'Normalized Difference Turbidity Index',
    rescale: '-1%2C1'
  }
  // {
  //   id: 'pri',
  //   value: 'pri',
  //   name: 'PRI',
  //   icon: '',
  //   description: 'Photochemical Reflectance Index',
  //   rescale: '-0.1%2C0.1'
  // }
];

export const colormaps = {
  ndvi: 'rplumbo',
  ndwi: 'ndwi',
  vari: 'cfastie',
  nbri: 'schwarzwald',
  ndbi: 'schwarzwald',
  'evi2-2': 'rplumbo',
  evi2: 'rplumbo',
  savi: 'rdylgn',
  rededge2: 'viridis',
  nddi: 'ylorrd',
  mtvi2: 'ylgn', // not working
  gemi: 'rdylgn', // not working
  lst: 'plasma',
  smi: 'rdylbu',
  osi: 'plasma', // not working
  tvi: 'ylgn', // not working
  ndre: 'rdylgn',
  msavi2: 'ylgn',
  reci: 'viridis',
  ndmi: 'rdylbu',
  gndvi: 'ylgn',
  sipi: 'ylgn',
  arvi: 'ylgn',
  psri: 'viridis',
  gci: 'ylgn',
  cvi: 'ylgn', // not working
  ndsi: 'blues_r',
  msi: 'rdylbu',
  // new indices
  rendvi: 'rdylgn',
  reip: 'ylgn',
  ari: 'turbo',
  nmdi_soil: 'plasma',
  nmdi_veg: 'spectral',
  si: 'ylgnbu',
  cmi: 'rdylbu',
  fmi: 'rdylbu',
  ioi: 'rdylbu',
  ci: 'jet',
  ndci: 'jet',
  fai: 'jet',
  mci: 'jet',
  mndwi: 'gnbu',
  pri: 'gnylrd'
};

// options related for rendering urls params from query-string package: https://www.npmjs.com/package/query-string
export const RenderOptions = {
  sort: false,
  strict: false,
  encode: false
};
